import { render, staticRenderFns } from "./GymnasticsListPage.vue?vue&type=template&id=66c2340c&scoped=true"
import script from "./GymnasticsListPage.vue?vue&type=script&lang=js"
export * from "./GymnasticsListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c2340c",
  null
  
)

export default component.exports